import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function LateEvening(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M15 1a1 1 0 011 1v1a1 1 0 11-2 0V2a1 1 0 011-1zm6.207 3.207a1 1 0 00-1.414-1.414l-1 1a1 1 0 001.414 1.414l1-1zM12.04 5.72a1 1 0 011.24-.68c2.8.816 5.013 2.97 5.69 5.72a1 1 0 11-1.94.48c-.492-1.993-2.127-3.644-4.31-4.28a1 1 0 01-.68-1.24zm-2.012.942a1 1 0 00-.842-1.657 9.023 9.023 0 00-8.147 8.146c-.46 4.96 3.187 9.349 8.146 9.81 4.961.46 9.35-3.187 9.81-8.146a1 1 0 00-1.59-.896 5.23 5.23 0 01-6.223-.001 5.234 5.234 0 01-1.2-7.183l.046-.073zm-2.619.807a7.039 7.039 0 00-3.904 3.901A7.015 7.015 0 009.37 20.97a7.016 7.016 0 007.164-4.38 7.229 7.229 0 01-6.541-1.063 7.236 7.236 0 01-2.584-8.057zM21 8a1 1 0 100 2h1a1 1 0 100-2h-1z",
    clipRule: "evenodd"
  }));
}

export default LateEvening;